import './EnhancedPopIn.module.scss'
import { useEffect } from 'react'
import { useModal } from '@commons/enhanced-modal/ModalContext.tsx'
import { ConfigProps } from './types.ts'
const EnhancedPopIn = (props: ConfigProps) => {
    const {
        autoOpenTime,
        autoCloseTime,
        openOnUserInactivity,
        autoOpenOnUserLeaving
    } = props

    const { open, close } = useModal()

    useEffect(() => {
        if (!autoOpenTime) return
        const ms = parseInt(autoOpenTime) * 1000
        if (isNaN(ms)) return

        const timeout = setTimeout(() => {
            open()
        }, ms)

        return () => clearTimeout(timeout)
    }, [autoOpenTime])

    useEffect(() => {
        if (!autoCloseTime) return
        const ms = parseInt(autoCloseTime) * 1000
        if (isNaN(ms)) return

        const timeout = setTimeout(() => {
            close()
        }, ms)

        return () => clearTimeout(timeout)
    }, [autoCloseTime])

    useEffect(() => {
        if (!autoOpenOnUserLeaving) return

        let triggered = false
        let exitTimeout: ReturnType<typeof setTimeout> | null = null

        const handleExitIntent = (event: MouseEvent) => {
            if (event.clientY <= 0 && !triggered) {
                exitTimeout = setTimeout(() => {
                    triggered = true
                    open()
                }, 800)
            }
        }

        const cancelIntent = () => {
            if (exitTimeout) {
                clearTimeout(exitTimeout)
                exitTimeout = null
            }
        }

        document.addEventListener('mouseleave', handleExitIntent)
        document.addEventListener('mousemove', cancelIntent)

        return () => {
            document.removeEventListener('mouseleave', handleExitIntent)
            document.removeEventListener('mousemove', cancelIntent)
            if (exitTimeout) clearTimeout(exitTimeout)
        }
    }, [autoOpenOnUserLeaving])

    useEffect(() => {
        if (!openOnUserInactivity?.enable) return

        const seconds = parseInt(openOnUserInactivity.time || '')
        if (isNaN(seconds)) return

        let timeout = setTimeout(() => {
            open()
        }, seconds * 1000)

        const resetTimer = () => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                open()
            }, seconds * 1000)
        }

        window.addEventListener('mousemove', resetTimer)
        window.addEventListener('keydown', resetTimer)

        return () => {
            clearTimeout(timeout)
            window.removeEventListener('mousemove', resetTimer)
            window.removeEventListener('keydown', resetTimer)
        }
    }, [openOnUserInactivity])

    return null
}

export default EnhancedPopIn
